module.exports = __webpack_public_path__ + "img/Account-Credit-Gradient.6a5eb23e.svg";